import React, { ReactNode, HTMLProps } from 'react'
import clsx from 'clsx'

import classes from './Button.module.scss'

export type ButtonProps = Omit<HTMLProps<HTMLButtonElement>, 'type'> & {
  color?: 'default' | 'primary' | 'secondary'
  startIcon?: ReactNode
  endIcon?: ReactNode
  fullWidth?: boolean
}

const Button: React.FC<ButtonProps> = ({
  color,
  startIcon,
  endIcon,
  children,
  fullWidth = false,
  className,
  ...rest
}) => {
  return (
    <button
      {...rest}
      className={clsx(classes.root, className, {
        [classes.secondary]: color === 'secondary',
        [classes.primary]: color === 'primary',
        [classes.fullWidth]: fullWidth,
      })}
    >
      {startIcon && (
        <span className={clsx(classes.iconWrapper, classes.startIcon)}>
          {startIcon}
        </span>
      )}

      {children}

      {endIcon && (
        <span className={clsx(classes.iconWrapper, classes.endIcon)}>
          {endIcon}
        </span>
      )}
    </button>
  )
}

export default Button
